import React, { Component } from "react";
//import * as _ from "lodash";
import seedrandom from "./seedrandom";

import QuizUi from "./widgets/QuizUi";

import { createQuestionFromSeed, pad2, dayOfWeek, daysInMonth } from "./QuizDay";

import {
  getLocaleShortWeekday,
  getLocaleLongWeekday,
  getLocaleLongMonth,
  getLocaleShortMonth,
} from "./util/localisation";

import "./QuizNth.css";

const strToParts = (str) => {
  const [, y, m, nth, day] = str.match(/^(\d{4})-(\d{2})-(\d):(\d)$/);
  return {
    year: parseInt(y, 10),
    month: parseInt(m, 10) - 1,
    nth: parseInt(nth, 10),
    day: parseInt(day, 10),
  };
};

export const describeNthQuestion = (str, compact) => {
  const { year, month, nth, day } = strToParts(str);
  if (compact) {
    return (
      ["Last", "1st", "2nd", "3rd", "fth"][nth] +
      " " +
      " " +
      getLocaleShortWeekday(day) +
      " of " +
      getLocaleShortMonth(month) +
      " " +
      year
    );
  } else {
    return (
      ["Last", "First", "Second", "Third", "Fourth"][nth] +
      " " +
      " " +
      getLocaleLongWeekday(day) +
      " of " +
      getLocaleLongMonth(month) +
      " " +
      year
    );
  }
};

export const solveNth = (str) => {
  const { year, month, nth, day } = strToParts(str);

  if (nth === 0) {
    const days = daysInMonth(year, month);
    const monthEndsOn = dayOfWeek(year, month, days);
    return days - ((monthEndsOn - day + 7) % 7);
  } else {
    const monthStartsOn = dayOfWeek(year, month, 1);
    const firstOfDay = 1 + ((day - monthStartsOn + 7) % 7);
    return firstOfDay + (nth - 1) * 7;
  }
};

class QuizNth extends Component {
  state = {
    puzzle: null,
    isCorrect: false,
    isWrong: false,
  };

  componentDidMount() {
    this.createQuestion();
  }

  componentDidUpdate(prevProps) {
    if (this.props.seed !== prevProps.seed) {
      this.createQuestion();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  createQuestion() {
    const { fromYear, toYear, seed } = this.props;

    const rng = new seedrandom(seed.random);

    const { year, month } = createQuestionFromSeed(seed, fromYear, toYear);

    const nth = rng.quick() < 1 / 3 ? 0 : 1 + Math.floor(rng.quick() * 4);
    const dayOfWeek = Math.floor(rng.quick() * 7);

    const puzzle = year + "-" + pad2(month + 1) + "-" + nth + ":" + dayOfWeek;

    this.setState({
      puzzle,
      firstDigit: null,
      isCorrect: false,
      answer: null,
    });
  }

  onAfterAnswerWait = (wasCorrect) => {
    if (wasCorrect) {
      this.props.resetSeed();
    }
    this.setState({
      answer: null,
      isWrong: false,
      isCorrect: false,
    });
  };

  render() {
    const { puzzle } = this.state;
    if (!puzzle) {
      return null;
    }

    const disabled = false; //isCorrect || isWrong;

    return [
      <NthQuestion
        key={puzzle}
        dateStr={puzzle}
        //displayFormat={displayFormat}
        hasSkip={false}
        onAnswer={this.onAnswer}
        disabled={disabled}
        onAfterAnswerWait={this.onAfterAnswerWait}
      />,
    ];
  }
}

export class NthQuestion extends Component {
  state = {
    answer: null,
  };

  onAnswer = (num, isSubmitMode) => {
    const { dateStr } = this.props;
    const { answer } = this.state;
    const trueAnswer = solveNth(dateStr);

    if (!isSubmitMode && trueAnswer >= 10 && num < 10) {
      // temporary answer
      const trueFirstDigit = Math.floor(trueAnswer / 10);
      if (trueFirstDigit === num) {
        return true; // await next digit
      }
      // otherwise flow on
    }

    const isCorrect = num === trueAnswer;

    this.setState({
      answer: num
    });

    if (isCorrect) {
      this.onAnswerCorrect();
    } else {
      this.onAnswerWrong(answer);
    }

    if (this.props.onAnswer) {
      this.props.onAnswer(isCorrect, num, null, false);
    }
  };

  onAnswerCorrect = () => {
    this.setState(
      {
        isCorrect: true,
        isWrong: false,
      },
      this.waitAfterAnswer
    );
  };

  onAnswerWrong = (answer) => {
    this.setState(
      {
        isWrong: true,
        isCorrect: false,
      },
      this.waitAfterAnswer
    );
  };

  waitAfterAnswer = () => {
    this.timeout = setTimeout(this.afterWait, 1000);
  };

  afterWait = () => {
    const wasCorrect = this.state.isCorrect;

    if (this.props.onAfterAnswerWait) {
      this.props.onAfterAnswerWait(wasCorrect, this.state.answer, null, false);
    }

    this.setState({
      answer: null,
      isWrong: false,
    });
  };

  render() {
    const { dateStr, children } = this.props;
    const { answer, isCorrect, isWrong } = this.state;

    const disabled = isCorrect || isWrong;

    return (
      <QuizUi
        className="QuizNth"
        twoDigits
        answer={answer}
        disabled={disabled}
        isCorrect={isCorrect}
        isWrong={isWrong}
        onAnswer={this.onAnswer}
       >
        {children}
        <strong className="-title">Calculate the day of the month</strong>
        <strong className="-question">{describeNthQuestion(dateStr)}?</strong>
      </QuizUi>
    );
  }
}

export default QuizNth;
